import update from 'react-addons-update';
import {
  LOGIN_POST_ERROR,
  LOGIN_CLEAR_ERROR,
  OPEN_FORGOT_MIMA_DAILOG,
  CLOSE_FORGOT_MIMA_DAILOG,
  OPEN_MIMA_SUCCESS_DAILOG,
  CLOSE_MIMA_SUCCESS_DAILOG,
} from './action.js';

const initState = {
  action: null,
  errors: null,
  showResultDialog: false,
  showForgotMimaDialog: false
};

export default function loginReducer(state = initState, action) {
  switch (action.type) {
    case LOGIN_POST_ERROR:
      return update(state, {
        errors: { $set: action.errors }
      });
    case LOGIN_CLEAR_ERROR:
      return update(state, {
        errors: { $set: initState.errors }
      });
    case OPEN_FORGOT_MIMA_DAILOG:
      return update(state, {
        showForgotMimaDialog: { $set: true }
      });
    case CLOSE_FORGOT_MIMA_DAILOG:
      return update(state, {
        showForgotMimaDialog: { $set: false }
      });
    case OPEN_MIMA_SUCCESS_DAILOG:
      return update(state, {
        showResultDialog: { $set: true }
      });
    case CLOSE_MIMA_SUCCESS_DAILOG:
      return update(state, {
        showResultDialog: { $set: false }
      });
    default:
      return state;
  }
}
